// Pure helper for the suite's 9-dot app switcher (suite task 68; used by app/SuiteSwitcher.jsx,
// tested in test/unit.test.mjs).
import { suiteOriginOf } from "../worker/src/suiteOrigin.js";

// The suite's origin for switcher.js's data-api: the first value that is an address switcher.js
// would accept (worker/src/suiteOrigin.js, the same rule the Worker uses for the suiteOrigin field
// it sends) and isn't this page itself (here).
export function suiteOriginFrom(urls, here) {
  for (const u of urls || []) {
    const o = suiteOriginOf(u);
    if (o && o !== here) return o;
  }
  return null;
}
